import React, {Fragment} from 'react';
import PropTypes from 'prop-types';
import './index.scss';

function InputErrorMessage({errorMessage}) {
	const renderError = message => (
		<div className={`app-input-error-message pl-0 d-flex align-items-center justify-content-center`}>
			<div className="col-auto p-0">
				{/*<img src={errorIcon} alt="" className="pr-1 icon-message" />*/}
			</div>
			<div className="col p-0">{message} </div>
		</div>
	);

	const renderErrors = () => {
		if (errorMessage && Array.isArray(errorMessage)) {
			return errorMessage.map((m, i) => <Fragment key={i}>{renderError(m)}</Fragment>);
		}
		return renderError(errorMessage);
	};

	return renderErrors();
}

InputErrorMessage.propTypes = {
	errorMessage: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
};
export default InputErrorMessage;
